import React from 'react';

import Skeleton from '../../atoms/Skeleton/Skeleton';
import { isMobile } from '../../../utils/platform';

const isDeviceMobile = isMobile();

const SkeletonInputTextAndLabel = () => {
  return (
    <article className="">
      <Skeleton height="18px" width={isDeviceMobile ? '100%' : '160px'} mb={4} />
      <Skeleton height="50px" width={isDeviceMobile ? '100%' : '270px'} mb={0} />
    </article>
  );
};
export default SkeletonInputTextAndLabel;
